import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { TextField, Paper, Button } from '@material-ui/core'
import AddService from './AddService'
import RecipientForm from './RecipientForm'
import Grid from '@material-ui/core/Grid'
import { sendAccounting } from '../../store/actions/customerAccountingActions'

const Accounting = ({config, recipient, services, user}) => {
  const handleSendAccounting = () => {
    return sendAccounting(user)

  }

  const sendBtnDisabled = recipient.name.length===0 || services.length===0
  return (
    <div style={{marginBottom: '1rem'}}>
        <Grid 
          container
          justifyContent="space-between"
          alignItems="stretch"
          spacing={1}
        >
            <Grid item md={6}>
              <RecipientForm config={config} recipient={recipient} />
            </Grid>
            <Grid item md={3}>
              <Paper
                style={{
                  backgroundColor: 'white',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '0 8px 0 8px',
                }}
              >
                <TextField
                  color='secondary'
                  label='Abrechnungs-Art'
                  disabled={true}
                  value={config.accountingType==='credit' ? 'Gutschrift' : 'Lastschrift'}
                /> 
              </Paper>
            </Grid>
            <Grid item md={3}>
            <Paper
              style={{
                padding: '0 8px 0 8px',
                backgroundColor: 'white',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              >
                <TextField
                  color='primary'
                  label='Abrechnungs-Nr.'
                  defaultValue={'MA-10001'}
                /> 
              </Paper>
              </Grid>
            <Grid item md={12}>
              <AddService/>
            </Grid>
            <Grid item md={12} >
              <Button
                onClick={handleSendAccounting}
                disabled={sendBtnDisabled}
                size='small'
                style={{marginTop: '1rem'}}
                variant='contained'
                color='primary'
              >
                Abrechnung Erstellen
              </Button>
            </Grid>
        </Grid>
    </div>
  )
}

export default compose(
   firestoreConnect(() => [  
    //  { collection: 'accounting', doc: 'pflegekasse', subcollections: [{ collection: 'services' }], storeAs: 'servicesPflegekasse' },
    //{ collection: 'tasks', where: [['type', '==', 'nachbarschaftshilfe']], storeAs: 'accountingTasks' }

]), // or { collection: 'todos' }
connect((state) => {

  return ({
    user: state.user,
    activeApp: state.user.settings.activeApp,
    recipient: state.customerAccounting.recipient,
    config: state.customerAccounting.config,
    services: state.customerAccounting.services
   // tasks: accountingTasks && accountingTasks,
  })}),
)(Accounting)

/*
<Recipient address={{name: 'Pflegekasse BGL', contactPerson: 'Max Mustermann', street: 'Musterstraße', city: '83395 Musterstadt'}}/>
const Recipient = ({address}) => {
  return (
    <Grid container spacing={0}>
      <Grid item md={6} container >
        <Grid item md={6}>
          <Typography variant='body1'>Name:</Typography>
        </Grid>
        <Grid item md={6}>
        <Typography color='primary' variant='body1'>{address.name}</Typography>
        </Grid>
      </Grid>
      <Grid item md={6} container >
        <Grid item md={6}>
        <Typography variant='body1'>Ansprechpartner</Typography>
        </Grid>
        <Grid item md={6}>
        <Typography color='primary' variant='body1'>{address.contactPerson}</Typography>
        </Grid>
      </Grid>
      <Grid item md={6} container >
        <Grid item md={6}>
          <Typography variant='body1'>Straße</Typography>
        </Grid>
        <Grid item md={6}>
        <Typography color='primary' variant='body1'>{address.street}</Typography>
        </Grid>
      </Grid>
      <Grid item md={6} container >
        <Grid item md={6}>
          <Typography variant='body1'>PLZ & Ort</Typography>
        </Grid>
        <Grid item md={6}>
          <Typography color='primary' variant='body1'>{address.city}</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}
*/